import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'rms-number',
  templateUrl: './number-field.component.html',
  styleUrl: '../rms-styles.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberFieldComponent),
      multi: true
    }
  ],
  imports: [CommonModule, FormsModule, MatIconModule]
})
export class NumberFieldComponent {
  @Input() currency: boolean = false;
  @Input() label: string = '';
  type: string = "number";
  placeholder: string = this.label;
  @Input() disabled: boolean = false;
  @Input() value: any;
  @Input() required: boolean = false;
  @Input() min: string = '';
  @Input() max: string = '';
  @Input() step: number = this.currency ? 0.01 : 1

  onChange = (_: any) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleInputChange(event: any) {
    this.value = event.target.value;
    this.onChange(this.value);
  }

}
